import { simulationActionTypes } from "./actionTypes";
import { ActionPayload } from "../stateAction";
import { mainActionTypes } from "../MainActionTypes";

export const updatesimulation = (simulationData: ActionPayload) => ({
    type: simulationActionTypes.UPDATE_SIMULATION,
    payload: simulationData
});

export const activateLoader = () => ({
	type: mainActionTypes.SET_LOADER_ACTIVE,
	payload: {}
});

export const deactivateLoader = () => ({
	type: mainActionTypes.SET_LOADER_INACTIVE,
	payload: {}
});
